import React from 'react'
import reactCSS from 'reactcss'
import { connect } from 'react-redux'
import SketchPicker from 'react-color'
import { Dialog, MenuItem, TextField } from '@mui/material'
import { ObjectTypeIcon } from '../icons.js'
import { sortArray } from '../../util.js'
import { DEFAULT_OBJECT_TYPE_COLOR } from '../style.js'
import EditBase from './EditBase.js'

const inputLabelProps = { shrink: true }
const selectStyle = { width: '100%' }

class EditObjectType extends EditBase {
  constructor (props) {
    super(props)

    const { strings } = this.props
    this.title = { text: strings.object_type, Icon: ObjectTypeIcon }

    const item = Object.assign({
      name: '',
      description: '',
      object_type_type: '--'
    }, props.item)

    if (!item.color) item.color = DEFAULT_OBJECT_TYPE_COLOR

    const saveDisabled = this.isSaveDisabled(item)
    this.state = {
      item,
      saveDisabled,
      displayColorPicker: false
    }

    this.handleColorPickerOpen = this.handleColorPickerOpen.bind(this)
    this.handleColorPickerClose = this.handleColorPickerClose.bind(this)
    this.handleColorPickerChange = this.handleColorPickerChange.bind(this)
  }

  handleColorPickerOpen () {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleColorPickerClose () {
    this.setState({ displayColorPicker: false })
  }

  handleColorPickerChange (color) {
    const { item } = this.state
    item.color = color.hex
    this.setState({ item })
  }

  isSaveDisabled (item) {
    return (item.name.length === 0 || item.object_type_type === '--')
  }

  handleChange (prop) {
    return (event) => {
      const { value } = event.target
      const { item } = this.state
      item[prop] = value
      const saveDisabled = this.isSaveDisabled(item)
      this.setState({ item, saveDisabled })
    }
  }

  renderColorPicker () {
    const { item } = this.state
    const styles = reactCSS({
      default: {
        color: {
          width: '36px',
          height: '20px',
          borderRadius: '2px',
          background: item.color
        },
        swatch: {
          marginTop: '5px',
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
          float: 'right'
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px'
        }
      }
    })

    const renderColorPickerDialog = () => {
      if (this.state.displayColorPicker) {
        return (
          <Dialog open>
            <div style={styles.cover} onClick={this.handleColorPickerClose} />
            <SketchPicker color={item.color} onChange={this.handleColorPickerChange} />
          </Dialog>
        )
      } else {
        return null
      }
    }

    return (
      <div>
        <div style={styles.swatch} onClick={this.handleColorPickerOpen}>
          <div style={styles.color} />
        </div>
        {renderColorPickerDialog()}
      </div>
    )
  }

  renderObjectTypeTypeList () {
    const { strings } = this.props

    const objectTypeTypes = sortArray([
      { value: '--', label: '--' },
      { value: 'contact', label: strings.contact },
      { value: 'department', label: strings.department },
      { value: 'project', label: strings.project },
      { value: 'category', label: strings.category },
      { value: 'contact_person', label: strings.contact_person },
      { value: 'employee', label: strings.employee }
    ], 'label')

    return objectTypeTypes.map((item, index) => (
      <MenuItem key={index} value={item.value}>
        {item.label}
      </MenuItem>
    ))
  }

  renderEditObjectTypeType () {
    const { strings, isEditing } = this.props
    const { item } = this.state

    if (isEditing) return null

    return (
      <TextField
        size='small'
        select
        label={strings.object_type_type}
        value={item.object_type_type}
        onChange={this.handleChange('object_type_type')}
        margin='dense'
        variant='outlined'
        style={selectStyle}
        required
      >
        {this.renderObjectTypeTypeList()}
      </TextField>
    )
  }

  renderContent () {
    const { strings } = this.props
    const { item } = this.state

    return (
      <>
        <TextField
          size='small'
          margin='dense'
          variant='outlined'
          label={strings.name}
          value={item.name || ''}
          fullWidth
          onChange={this.handleChange('name')}
          InputLabelProps={inputLabelProps}
          autoFocus
          required
        />
        <TextField
          size='small'
          margin='dense'
          variant='outlined'
          label={strings.description}
          value={item.description || ''}
          fullWidth
          onChange={this.handleChange('description')}
          InputLabelProps={inputLabelProps}
        />
        {this.renderEditObjectTypeType()}
        {this.renderColorPicker()}
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    strings: state.locale.strings
  }
}

export default connect(mapStateToProps)(EditObjectType)
